<div>
  <b>{{getAvatar()}}</b>
</div>